// extracted by mini-css-extract-plugin
export var cartContainer = "_pd-4";
export var gray = "_pd-1";
export var itemContainer = "_pd-2";
export var itemDetails = "_pd-3";
export var strong = "_pd-0";